/**
 * The Arena's stand-in service rates.
 *
 * CONFIDENTIAL — ASI Internal.
 *
 * THESE ARE APPROVED FIGURES AND THEY ARE STILL NOT THE SOURCE OF TRUTH. The
 * Partnership Net Pricing Engine owns rates (DEC-48); it is not live, so this
 * table exists so a scope decision has a visible consequence on screen in the
 * meantime. Every quote built from it says so in its provenance line.
 *
 * ONE COPY, NOT TWO — eventually. `AGENT_COMMERCIALS` in
 * `src/domain/mmm/engine/dqs/config.ts` still carries the same three figures for
 * the MMM engine's own indicative cost. Two sources for one approved figure is
 * how a quote goes out wrong, so `tests/domain/quote/rateDrift.test.ts` fails
 * the build the moment they disagree. That test is scaffolding: it is deleted
 * together with the engine copy when the engine reads its fees through the port
 * (OPEN-BUILDER-16).
 *
 * Figures are EUR, PO-approved (OPEN-ITEMS NEW-40, 2026-09-15). Lead times are
 * working days. Nothing here is invented — a service with no approved rate is
 * absent rather than guessed, and a scope naming it says so on the screen.
 */

import type { ServiceRateTable } from '@/domain/quote/model';

export const SERVICE_PRICING_CURRENCY = 'EUR';

export const SERVICE_RATES: ServiceRateTable = {
  dqs_assessment: {
    service: 'dqs_assessment',
    label: 'Data Confidence Score',
    unitFee: 1200,
    leadTimeDays: 5,
  },
  data_recommendation: {
    service: 'data_recommendation',
    label: 'Data Recommendation Agent',
    unitFee: 1800,
    leadTimeDays: 3,
  },
  data_qa: {
    service: 'data_qa',
    label: 'Data Quality Assurance',
    unitFee: 2900,
    leadTimeDays: 10,
  },
};
